import React, { useState, useRef  } from 'react';
import {
    Grid,
    Typography,
    IconButton,
    TextField,
    Select,
    MenuItem,
    Box,
    Divider,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import imagen_prueba from '../../../assets/image/imagen_puerta.png';
import { moneyFormat } from '../../../toolbox/helpers/money-helpers';

export const ProductShoppingCart = ({
    products,
    deleteProductCartAPI,
    handleDismissProduct,
    handleMoreProduct,
    handleInputQuantityChange,
    validateQuantity,
    discountType,
    setDiscountType,
    editIndex,
    editedDiscount,
    setEditedDiscount,
    handleSaveDiscount,
    handleEditDiscount
}) => {

    const inputRef = useRef<HTMLInputElement>(null);

    const handleFocus = () => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100); 
    }

    return (
        <Box sx={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
            <Grid container direction="column" spacing={2}>
                {products.map((product, i) => (
                    <Grid
                        container
                        key={i}
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            padding: '25px',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                            alignItems: 'center',
                        }}
                    >
                        {/* Imagen del Producto */}
                        <Grid item xs={2}>
                            <img
                                src={product.image || imagen_prueba}
                                alt={product.name_product}
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                }}
                            />
                        </Grid>

                        {/* Detalles del Producto */}
                        <Grid item xs={5}>
                            <Typography variant="subtitle1" fontWeight="bold" noWrap>
                            ({product.codeerp_product}) {product.name_product} 
                            </Typography>
                            <Box display="flex" alignItems="center" mt={1}>
                                {editIndex === i ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <TextField
                                            type="number"
                                            value={editedDiscount}
                                            onChange={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (discountType === '2' && value > 100) {
                                                    setEditedDiscount(100); 
                                                } else if (value < 0) {
                                                    setEditedDiscount(0);
                                                } else {
                                                    setEditedDiscount(value);
                                                }
                                            }}
                                            size="small"
                                            sx={{ maxWidth: '80px' }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSaveDiscount(i); 
                                                }
                                            }}
                                            inputProps={{
                                                min: 0
                                            }}
                                            inputRef={inputRef} 
                                        />
                                        <Select
                                            value={discountType}
                                            onChange={(e) => setDiscountType(e.target.value)}
                                            size="small"
                                            sx={{ maxWidth: '80px' }}
                                        >
                                            <MenuItem value="2">%</MenuItem>
                                            <MenuItem value="1">$</MenuItem>
                                        </Select>
                                        <IconButton onClick={() => handleSaveDiscount(i)} color="primary">
                                            <SaveIcon />
                                        </IconButton>
                                    </Box>
                                ) : (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography
                                            sx={{
                                                backgroundColor: '#FF4747',
                                                color: '#fff',
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                            }}
                                        >
                                            -{product.discount || 0} {product.discounttype === '2' ? '%' : '$'}
                                        </Typography>
                                        <IconButton onClick={() => {handleEditDiscount(i); setDiscountType(product.discounttype); handleFocus();}}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* Cantidad y Precio */}
                        <Grid item xs={3}>
                            <Box display="flex" alignItems="center" justifyContent="center" mt={1}>

                                <Typography fontWeight="bold" textAlign="center" fontSize="small">
                                    {moneyFormat(product.price, '$')}
                                </Typography>
                            </Box>

                            <Box display="flex" alignItems="center" justifyContent="center" mt={1}>
                                <IconButton
                                    onClick={() => handleDismissProduct(i)}
                                    sx={{
                                        backgroundColor: '#e0e0e0',
                                        '&:hover': { backgroundColor: '#bdbdbd' },
                                    }}
                                >
                                    <RemoveIcon fontSize="small" />
                                </IconButton>
                                {/* <Typography mx={2}>{product.quantity}</Typography> */}
                                <TextField
                                    value={product.quantity}
                                    onChange={(e) => handleInputQuantityChange(e, i)}
                                    onBlur={() => validateQuantity(i)}
                                    type="number"
                                    size="small"
                                    sx={{
                                        width: 60,
                                        textAlign: 'center',
                                        mx: 2,
                                        '& .MuiInputBase-root': { textAlign: 'center' },
                                    }}
                                    inputProps={{
                                        min: 1, 
                                    }}
                                />
                                <IconButton
                                    onClick={() => handleMoreProduct(i)}
                                    sx={{
                                        backgroundColor: '#e0e0e0',
                                        '&:hover': { backgroundColor: '#bdbdbd' },
                                    }}
                                >
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            </Box>

                            {/* Mostrar el precio con descuento si existe descuento */}
                            {product.discount && product.discount > 0 ? (
                                <Box display="flex" alignItems="center" justifyContent="center" mt={1}>

                                    <Typography
                                        color="text.secondary"
                                        sx={{ textDecoration: 'line-through' }}
                                    >
                                        {moneyFormat(product.quantity * product.price, '$')}
                                    </Typography>
                                    <Typography fontWeight="bold" color="primary" ml={1}>
                                        {moneyFormat(product.gross_subtotal, '$')}
                                    </Typography>
                                </Box>
                            ) : (
                                    <Box display="flex" alignItems="center" justifyContent="center" mt={1}>

                                        <Typography
                                            fontWeight="bold"
                                            color="text.secondary"
                                            textAlign="center"
                                        >
                                            {moneyFormat(product.quantity * product.price, '$')}
                                        </Typography>
                                    </Box>

                            )}
                        </Grid>


                        {/* Eliminar */}
                        <Grid item xs={2} display="flex" justifyContent="flex-end">
                            <IconButton
                                onClick={() => deleteProductCartAPI(product.id)}
                                sx={{
                                    backgroundColor: '#ffcccc',
                                    '&:hover': { backgroundColor: '#ff9999' },
                                }}
                            >
                                <DeleteOutlineIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
